export const API_CONFIG = {
  API_TOKEN: 'Bearer 3185723b6c2dcc7b04919582d1c09edb8db7fc79efec04c3fd52ccf4fc072daa0dcd50f82fe67f7fdd3094c0da1827a51224295397742b6c41d3c4f6d48079d7e2456a0b1914c57d99fb43ea90c704ae6b57c7df3f995418457c236372ed730e6092766c1e54cd17c4453e09c800d2adae94e80f05af5cbe1ba95a731324a41c',
  BASE_URL: 'https://strapi.onixx.ru/'
} as const;
